import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RequestBodyConverter } from '../RequestBodyConverter';
import { useParams } from 'react-router-dom';
import CardSkinForm from './CardSkinForm';
// import { initialValues  } from './initialValues-testing';
import { showCardSkinApi, updateCardSkinApi, clearEditedCardSkin } from './cardSkinSlice';
import { clearApiValidationErrors } from '~/stores/redux/common/apiValidationErrorSlice';
import { pictureAttributeNames } from './initialValue';
import uploadImage from '~/api/uploadImage';

function CardSkinUpdate() {
    const { id } = useParams();
    const [resetCount, setResetCount] = useState(0);
    const { editedModel: initialValues } = useSelector((state) => state.itemSaga.cardSkin);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const formSubmit = async (values) => {
        dispatch(clearApiValidationErrors()); //clear current api validation errors if any.
        await uploadImage(values, pictureAttributeNames, 'card-skins');
        dispatch(updateCardSkinApi({ navigate, values, id }));
    };

    useEffect(() => {
        dispatch(showCardSkinApi({ navigate, id }));

        return () => dispatch(clearEditedCardSkin());
    }, []);

    return (
        <CardSkinForm
            resetCount={resetCount}
            setResetCount={setResetCount}
            pictureAttributeNames={pictureAttributeNames}
            initialValues={initialValues}
            formSubmit={formSubmit}
        />
    );
}

export default CardSkinUpdate;
